/* Limited Prep Gym engine. One drill box per page: <div class="ld" data-ldrill data-set="apologetics" ...>.
   Questions come from window.LDRILL_SETS[set] = { cats: [...], questions: [[catIndex, text, isNew, citation, hint], ...] }.
   Free-prompt count and the email unlock are shared across every event. */
(function () {
  var root = document.querySelector('[data-ldrill]');
  if (!root) return;
  var set = (window.LDRILL_SETS || {})[root.dataset.set];
  if (!set) return;
  var CATS = set.cats, Q = set.questions;
  // a prompt tied to a date (an election) carries q[6] = 'YYYY-MM-DD', the first day it is no longer drawn
  var now = new Date(), today = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
  Q = Q.filter(function (q) { return !q[6] || today < q[6]; });
  var d = root.dataset;
  var FREE = +d.free || 5, PREP = +d.prep || 240, SPEECH = +d.speech || 360,
      GRACE = d.grace === undefined ? 15 : +d.grace,      // 0 = no overtime penalty shown
      DRAW = +d.draw || 3,                                 // topics in a tournament draw; 1 = single draw only
      SAMECAT = d.samecat !== '0',                         // tournament draw from one category?
      ONE = d.labelOne || 'Draw a question', MANY = d.labelMany || 'Draw three topics';
  // debate events list their speeches one per line: "Prime Minister Constructive | 7:00 | POI"
  var SPEECHES = (d.speeches || '').split(/\r?\n/).map(function (line) {
    var p = line.split('|').map(function (x) { return x.trim(); });
    if (p.length < 2 || !p[0]) return null;
    var t = p[1].split(':');
    return { name: p[0], max: t.length > 1 ? (+t[0]) * 60 + (+t[1]) : +t[0], poi: /poi/i.test(p[2] || '') };
  }).filter(function (x) { return x && x.max > 0; });
  var $ = function (sel) { return root.querySelector(sel); };

  /* ---- storage (never trusted to exist) ---- */
  var mem = { used: 0, unlocked: false };
  function sget(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function used() { var v = sget('ldrill.used'); return v === null ? mem.used : (parseInt(v, 10) || 0); }
  function unlocked() { return sget('ldrill.unlocked') === '1' || mem.unlocked; }
  function bump() { mem.used = used() + 1; sset('ldrill.used', mem.used); }
  function unlock() { mem.unlocked = true; sset('ldrill.unlocked', '1'); }

  /* Shopify re-renders the page after the email form posts; the section leaves a marker. */
  if (document.querySelector('[data-ld-unlock]')) unlock();

  /* ---- count ---- */
  function renderCount() {
    var n = Math.max(0, FREE - used());
    $('[data-ld-left]').innerHTML = unlocked() ? 'Unlimited prompts'
      : n ? '<b>' + n + ' of ' + FREE + '</b> free prompts left'
      : '<b>Free prompts used.</b> Add your email to keep drawing.';
  }

  /* ---- categories: a dropdown of "All" plus each category ---- */
  var sel = [], catSel = $('[data-ld-cat]');
  CATS.forEach(function (c, i) { var o = document.createElement('option'); o.value = i; o.textContent = c; catSel.appendChild(o); });
  catSel.addEventListener('change', function () { sel = catSel.value === 'all' ? [] : [+catSel.value]; });
  var mode = 'quick', drawBtn = $('[data-ld-draw]');
  root.querySelectorAll('[data-ld-mode]').forEach(function (b) {
    b.addEventListener('click', function () {
      mode = b.dataset.ldMode;
      root.querySelectorAll('[data-ld-mode]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      drawBtn.textContent = mode === 'quick' ? ONE : MANY;
    });
  });
  drawBtn.textContent = ONE;
  if (DRAW < 2) $('[data-ld-seg]').hidden = true;

  /* ---- drawing ---- */
  var last = [], current = null, table = $('[data-ld-table]');
  /* Each browser remembers which prompts it has seen (by a short hash of the text, so it survives
     new prompts being added) and doesn't repeat one until every prompt in the chosen types is used. */
  function hash(s) { for (var x = 5381, k = 0; k < s.length; k++) x = ((x << 5) + x + s.charCodeAt(k)) | 0; return (x >>> 0).toString(36); }
  var KEY = Q.map(function (q) { return hash(q[1]); }), SEENKEY = 'ldrill.seen.' + root.dataset.set,
      seen = (sget(SEENKEY) || '').split(',').filter(Boolean);
  function isSeen(i) { return seen.indexOf(KEY[i]) >= 0; }
  function markSeen(ids) {
    ids.forEach(function (i) { if (!isSeen(i)) seen.push(KEY[i]); });
    if (seen.length > 3000) seen = seen.slice(-3000);
    sset(SEENKEY, seen.join(','));
  }
  function unseen(pool, n) {         // the unseen part of a pool; once it runs dry, that pool starts over
    var fresh = pool.filter(function (i) { return !isSeen(i) && last.indexOf(i) < 0; });
    if (fresh.length >= n) return fresh;
    seen = seen.filter(function (k) { return !pool.some(function (i) { return KEY[i] === k; }); });
    var rest = pool.filter(function (i) { return last.indexOf(i) < 0; });
    return rest.length >= n ? rest : pool;
  }
  function poolOf(cats) { return Q.map(function (q, i) { return i; }).filter(function (i) { return cats.indexOf(Q[i][0]) >= 0; }); }
  function pick(n) {
    var cats = sel.length ? sel : CATS.map(function (x, i) { return i; }), pool;
    if (n > 1 && !SAMECAT && cats.length >= n) return pickAcross(n, cats);
    if (n > 1 && SAMECAT) {          // a tournament draw comes from one category, preferably one with enough topics
      var big = cats.filter(function (c) { return poolOf([c]).length >= n; });
      if (!big.length) big = cats;
      pool = poolOf([big[Math.floor(Math.random() * big.length)]]);
    } else pool = poolOf(cats);
    pool = unseen(pool, n);
    var out = [];
    n = Math.min(n, pool.length);    // never ask for more topics than the category holds
    while (out.length < n) { var i = pool[Math.floor(Math.random() * pool.length)]; if (out.indexOf(i) < 0) out.push(i); }
    last = out; markSeen(out); return out;
  }
  function pickAcross(n, cats) {    // one topic from each of n different categories
    cats = cats.slice().sort(function () { return Math.random() - .5; }).slice(0, n);
    last = cats.map(function (cat) {
      var pool = unseen(poolOf([cat]), 1);
      return pool[Math.floor(Math.random() * pool.length)];
    }).filter(function (i) { return i !== undefined; });
    markSeen(last); return last;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML.replace(/"/g, '&quot;'); }
  /* Some prompts are not words: q[5] is {shape, color} (drawn here) or {img, alt} (a theme asset). */
  var ASSETS = d.assets || '';
  var SHAPES = {
    square: '<rect x="27" y="27" width="46" height="46"/>',
    circle: '<circle cx="50" cy="50" r="25"/>',
    triangle: '<polygon points="50,24 78,74 22,74"/>',
    diamond: '<polygon points="50,22 76,50 50,78 24,50"/>',
    hexagon: '<polygon points="50,24 73,37 73,63 50,76 27,63 27,37"/>',
    star: '<polygon points="50,22 57,42 78,42 61,55 67,76 50,63 33,76 39,55 22,42 43,42"/>',
    line: '<rect x="18" y="48" width="64" height="4"/>',
    dot: '<circle cx="50" cy="50" r="5"/>',
    ring: '<circle cx="50" cy="50" r="23" fill="none" stroke-width="7"/>',
    outline: '<rect x="28" y="28" width="44" height="44" fill="none" stroke-width="4"/>',
    half: '<path d="M24 60a26 26 0 0 1 52 0z"/>',
    dots: '<circle cx="30" cy="50" r="8"/><circle cx="50" cy="50" r="8"/><circle cx="70" cy="50" r="8"/>',
    wave: '<path d="M16 50q8.5-16 17 0t17 0 17 0 17 0" fill="none" stroke-width="5" stroke-linecap="round"/>',
    arrow: '<path d="M22 46h40V34l18 16-18 16V54H22z"/>'
  };
  function mediaHTML(q) {
    var m = q[5];
    if (m.img) return '<div class="ld-pic"><img src="' + ASSETS + esc(m.img) + '" alt="' + esc(m.alt || q[1]) + '"></div>';
    if (m.shape === 'wash') return '<div class="ld-wash" role="img" aria-label="' + esc(q[1]) + '" style="background:' + esc(m.color) + '"></div>';
    return '<div class="ld-shape"><svg viewBox="0 0 100 100" role="img" aria-label="' + esc(q[1]) + '" fill="' + esc(m.color) + '" stroke="' + esc(m.color) + '">' + (SHAPES[m.shape] || SHAPES.square) + '</svg></div>';
  }
  function cardHTML(i, pickable) {
    var q = Q[i], body = q[5] ? mediaHTML(q) + (q[3] ? '<div class="ld-credit">' + esc(q[3]) + '</div>' : '')
      : '<div class="ld-lines"><div class="ld-q">' + esc(q[1]) + '</div>' + (q[3] ? '<div class="ld-cite">' + esc(q[3]) + '</div>' : '') + '</div>';
    return '<div class="ld-icard ld-deal' + (q[5] ? ' is-plain' : '') + '"' + (pickable ? ' tabindex="0" role="button" data-i="' + i + '"' : '') + '>' +
      '<div class="ld-cat"><span>' + esc(CATS[q[0]]) + '</span>' + (q[2] ? '<span class="ld-new">New this season</span>' : '') + '</div>' +
      body + '</div>';
  }
  function showOne(i) {
    current = i; table.classList.remove('ld-fan'); table.innerHTML = cardHTML(i);
    setHintButton();
  }
  drawBtn.addEventListener('click', function () {
    if (!unlocked() && used() >= FREE) { openGate(); return; }
    bump(); renderCount(); hideHint();
    if (!Q.length) return;
    if (mode === 'quick') { showOne(pick(1)[0]); }
    else {
      current = null; setHintButton();
      table.classList.add('ld-fan');
      table.innerHTML = pick(DRAW).map(function (i) { return cardHTML(i, true); }).join('') +
        '<p class="ld-fan-note">Prep has started. Pick the topic you want to speak on.</p>';
      table.querySelectorAll('.ld-icard').forEach(function (el) {
        el.addEventListener('click', function () { showOne(+el.dataset.i); });
        el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showOne(+el.dataset.i); } });
      });
    }
    startPrep();
  });

  /* ---- hint: shown only for questions that have one written ---- */
  var hintBtn = $('[data-ld-hintbtn]'), hintBox = $('[data-ld-hint]');
  function setHintButton() { hintBtn.hidden = current === null || !Q[current][4]; }
  function hideHint() { hintBox.hidden = true; hintBtn.textContent = 'Show a hint'; }
  hintBtn.addEventListener('click', function () {
    if (current === null || !Q[current][4]) return;
    if (!hintBox.hidden) { hideHint(); return; }
    hintBox.innerHTML = Q[current][4];
    hintBox.hidden = false; hintBtn.textContent = 'Hide hint';
  });

  /* ---- timer: prep counts down, speech counts up ----
     Time is measured from the clock, not by counting ticks, because browsers slow
     timers in background tabs (a student researching during extemp prep). */
  var phase = 'idle', left = PREP, elapsed = 0, tick = null, running = false, acc = 0, t0 = 0;
  function secs() { return acc + (running ? Math.floor((Date.now() - t0) / 1000) : 0); }
  function restartCount() { acc = 0; t0 = Date.now(); elapsed = 0; }
  var clock = $('[data-ld-clock]'), sub = $('[data-ld-sub]'), bar = $('[data-ld-bar]'),
      speechBtn = $('[data-ld-speech]'), pauseBtn = $('[data-ld-pause]');
  function fmt(s) { return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); }
  var sIdx = 0, speechSel = $('[data-ld-speechsel]'), nextBtn = $('[data-ld-next]');
  if (SPEECHES.length) {
    SPEECHES.forEach(function (sp, i) { var o = document.createElement('option'); o.value = i; o.textContent = sp.name + ' (' + fmt(sp.max) + ')'; speechSel.appendChild(o); });
    speechSel.hidden = false;
    speechSel.addEventListener('change', function () { sIdx = +speechSel.value; SPEECH = SPEECHES[sIdx].max; if (phase === 'speech') restartCount(); renderTimer(); });
    nextBtn.addEventListener('click', function () { if (sIdx < SPEECHES.length - 1) { sIdx++; speechSel.value = sIdx; SPEECH = SPEECHES[sIdx].max; phase = 'speech'; acc = 0; run(); } });
    SPEECH = SPEECHES[0].max;
  }
  function poiNote() {               // points of information: open after the first minute, closed in the last
    var sp = SPEECHES[sIdx]; if (!sp) return '';
    if (!sp.poi) return ' No POIs in rebuttals.';
    return elapsed < 60 || elapsed >= sp.max - 60 ? ' Protected time: no POIs.' : ' POIs open.';
  }
  function renderTimer() {
    clock.className = 'ld-clock';
    if (phase === 'speech') {
      $('[data-ld-phase]').textContent = SPEECHES.length ? SPEECHES[sIdx].name : 'Speech';
      clock.textContent = fmt(elapsed);
      var over = elapsed - SPEECH;
      if (GRACE && over >= GRACE) { clock.classList.add('is-over'); sub.textContent = 'Over by ' + over + ' seconds. That costs a rank.'; }
      else if (over > 0) { clock.classList.add(GRACE ? 'is-warn' : 'is-over'); sub.textContent = 'Time is up. Wrap up now.'; }
      else if (elapsed >= SPEECH - 60) { clock.classList.add('is-warn'); sub.textContent = 'One minute left.' + poiNote(); }
      else sub.textContent = 'Counts up to ' + fmt(SPEECH) + '.' + poiNote();
      bar.style.width = Math.min(100, elapsed / SPEECH * 100) + '%';
    } else {
      $('[data-ld-phase]').textContent = 'Prep time';
      clock.textContent = fmt(left);
      if (phase === 'idle') sub.textContent = 'Starts when you draw.';
      else if (left <= 0) sub.textContent = 'Prep is over. Start your speech.';
      else if (left <= 30) { clock.classList.add('is-warn'); sub.textContent = '30 seconds of prep left.'; }
      else sub.textContent = running ? 'Counting down.' : 'Paused.';
      bar.style.width = ((PREP - left) / PREP * 100) + '%';
    }
    pauseBtn.textContent = running || phase === 'idle' ? 'Pause' : 'Resume';
    pauseBtn.disabled = phase === 'idle' || (phase === 'prep' && left <= 0);
    speechBtn.disabled = phase === 'speech';
    if (SPEECHES.length) nextBtn.hidden = phase !== 'speech' || sIdx >= SPEECHES.length - 1;
  }
  function update() {
    var t = secs();
    if (phase === 'prep') {
      left = Math.max(0, PREP - t);
      if (left === 0) { acc = PREP; running = false; clearInterval(tick); }
    } else if (phase === 'speech') elapsed = t;
    renderTimer();
  }
  function run() {          // start or resume counting from the time already used (acc)
    clearInterval(tick); running = true; t0 = Date.now();
    tick = setInterval(update, 250);
    update();
  }
  function pause() { acc = secs(); running = false; clearInterval(tick); update(); }
  function startPrep() { phase = 'prep'; acc = 0; elapsed = 0; run(); }
  speechBtn.addEventListener('click', function () { phase = 'speech'; acc = 0; elapsed = 0; run(); });

  pauseBtn.addEventListener('click', function () { if (running) pause(); else run(); });
  $('[data-ld-reset]').addEventListener('click', function () {
    clearInterval(tick); running = false; phase = 'idle'; left = PREP; elapsed = 0; acc = 0;
    if (SPEECHES.length) { sIdx = 0; speechSel.value = 0; SPEECH = SPEECHES[0].max; }
    renderTimer();
  });

  /* ---- email gate (a real Shopify customer form; closing it never unlocks) ---- */
  var gate = root.querySelector('[data-ld-gate]'), form = gate.querySelector('form'),
      email = gate.querySelector('input[type=email]'), err = gate.querySelector('[data-ld-gerr]');
  function openGate() { gate.classList.add('is-open'); email.focus(); }
  function closeGate() { gate.classList.remove('is-open'); drawBtn.focus(); }
  gate.querySelectorAll('[data-ld-close]').forEach(function (b) { b.addEventListener('click', closeGate); });
  gate.addEventListener('click', function (e) { if (e.target === gate) closeGate(); });
  gate.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeGate(); });
  form.addEventListener('submit', function (e) {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) { e.preventDefault(); err.textContent = 'Enter an email address like john.doe@example.com.'; }
  });
  if (err.textContent.trim()) openGate();

  renderCount(); renderTimer();
})();
